/**
 * Names of the upload service's own rejections, kept in a dependency-free module so light callers (the image editor's
 * edge transport and its jest spec) can read the real values without loading services/file-upload.service.ts and its
 * whole service graph. Loading that graph inside the edge-transport spec hung 8 tests (integration gate, 2026-10-07).
 * services/file-upload.service.ts re-exports both names, so they have one source.
 */
export const EMPTY_FILE_ERROR_NAME = 'File is empty';
export const FILE_TOO_LARGE_ERROR_NAME = 'File is too large';
